import React, { useEffect, useState } from "react";

//ANT DESIGN
import ImgCrop from "antd-img-crop";
import {
  LeftOutlined,
  UploadOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  UserOutlined,
  CameraOutlined,
} from "@ant-design/icons";
import {
  Button,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Spin,
  Form,
  Descriptions,
  Divider,
  Flex,
  Tooltip,
  Upload,
  Avatar,
  Space,
  Image,
  Modal,
  message,
} from "antd";
import CustomerPic from "../../../../assets/images/empty-profile-picture.png";
import signature from "../../../../assets/images/signature.png";
import mockCustomers from "../../../../config/data/mockPeople.json";
import { Pie, measureTextWidth } from "@antv/g2plot";

//PROJECT IMPORTS
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import { handleFlgStatus } from "../../../../components/facilities/AccountFacility";
import styles from "../../../../assets/styles/styles";
import axios from "axios";
import appConfig from "../../../../config/appConfig";

const { Text } = Typography;

export default function CustomerInfo(props) {
  const { currentCustomerObj, session } = props;
  const [customerDetails, setCustomerDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${currentCustomerObj.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setIsLoading(false);
        // setCustomerDetails(objDetail);
        setIsLoading(false);
      }
    });
  };

  return (
    <Card
      style={{
        marginBottom: 25,
        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
        borderRadius: 20,
      }}
      title={
        <Row
          style={{
            alignContent: "center",
            width: "8%",
          }}
        >
          <Button
            icon={<LeftOutlined />}
            type="text"
            style={{
              marginTop: "auto",
              marginBottom: "auto",
            }}
            onClick={props.backOnClick}
          >
            <Text style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}>Back</Text>
          </Button>
        </Row>
      }
    >
      <Row>
        <Col span={10}>
          <CustomerDetailsCard
            customerDetails={currentCustomerObj}
            session={session}
            spinning={isLoading}
          />
        </Col>
        <Col span={7} style={{ padding: "0px 8px" }}>
          <AssetPositionCard />
        </Col>
        <Col span={7}>
          <LiabilityPositionCard />
        </Col>
      </Row>
    </Card>
  );
}

function CustomerDetailsCard(props) {
  const { customerDetails, session } = props;
  const [isShowSignature, setIsShowSignature] = useState(false);
  const [onEditShow, setOnEditShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [profileImageList, setProfileImageList] = useState([]);
  const [disableDelete, setDisableDelete] = useState(false);
  const [isUploadDisabled, setIsUploadDisabled] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [isProfileModalVisible, setIsProfileModalVisible] = useState(false);
  const [profileImageData, setProfileImageData] = useState(null);
  const [hasLoadedImage, setHasLoadedImage] = useState(false);
  const [isCameraActive, setIsCameraActive] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const videoRef = React.useRef(null);
  const canvasRef = React.useRef(null);
  const displayStatus = handleFlgStatus(customerDetails?.status?.value, {
    fontSize: 16,
  });

  useEffect(() => {
    if (BOM.HasPermission("READ_DOCUMENT")) {
      getSignature();
      getProfileImage();
    }
  }, []);

  // Clean up camera stream when component unmounts
  useEffect(() => {
    return () => {
      if (cameraStream) {
        cameraStream.getTracks().forEach((track) => track.stop());
      }
    };
  }, [cameraStream]);

  const getSignature = async () => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${customerDetails.id}/documents`;
    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, async (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = BOM.GetUnique(res, "name");
        const signature = objList.find((item) => item.name?.toLowerCase() === "clientsignature");
        if (signature) {
          const signatureImage = await getSignatureImage(signature);
          setFileList([
            {
              uid: signature.id,
              name: "image.png",
              status: "done",
              // url: `${apiConfig.Clients}/${customerDetails.id}/documents/${signature.id}/attachment?tenantIdentifier=default`,
              url: signatureImage,
            },
          ]);
        }
        setIsLoading(false);
      }
    });
  };

  const getProfileImage = () => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${customerDetails.id}/images`;
    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        // Don't show error message for missing image, just set loading to false
        setIsLoading(false);
        setHasLoadedImage(true);
      } else {
        try {
          // Check if there's a profile image
          if (res && res.length > 0) {
            // If the response is base64 data directly
            if (typeof res === "string" && res.startsWith("data:image")) {
              setProfileImageData(res);
            }
            // If the response is an array with image info
            else if (
              Array.isArray(res) &&
              res[0] &&
              res[0].contentType &&
              res[0].contentType.includes("image")
            ) {
              // This would be the case if the API returns image metadata
              const imageId = res[0].id;
              setProfileImageData({
                id: imageId,
                url: `${apiConfig.Clients}/${customerDetails.id}/images/${imageId}?tenantIdentifier=default`,
              });
            }
            // If the first item has base64 data
            else if (res[0] && typeof res[0] === "string" && res[0].startsWith("data:image")) {
              setProfileImageData(res[0]);
            }
            // If we get the actual base64 string without the prefix
            else if (res && typeof res === "string") {
              // Check if it's a base64 string without the data:image prefix
              if (isBase64(res)) {
                setProfileImageData(`data:image/jpeg;base64,${res}`);
              }
            }
          }
        } catch (error) {}

        setHasLoadedImage(true);
        setIsLoading(false);
      }
    });
  };

  // Helper function to check if a string is base64 encoded
  const isBase64 = (str) => {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const onProfileImageChange = ({ fileList: newFileList }) => {
    setProfileImageList(newFileList);
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const showProfileModal = () => {
    setIsProfileModalVisible(true);
    setIsCameraActive(false); // Reset camera state when opening modal
  };

  const handleProfileModalCancel = () => {
    setIsProfileModalVisible(false);
    setProfileImageList([]); // Clear the upload list when canceling

    // Stop camera if it's active
    if (isCameraActive && cameraStream) {
      cameraStream.getTracks().forEach((track) => track.stop());
      setCameraStream(null);
    }
    setIsCameraActive(false);
  };

  const handleProfileUpload = () => {
    if (profileImageList.length === 0 && !isCameraActive) {
      message.warning("Please select an image first");
      return;
    }

    setIsLoading(true);

    // Handle camera capture
    if (isCameraActive) {
      const canvas = canvasRef.current;
      const video = videoRef.current;

      if (canvas && video) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Convert to blob with explicit filename and type
        canvas.toBlob(
          (blob) => {
            // Create a file from blob with proper filename and type
            const imageFile = new File([blob], "camera-capture.jpg", {
              type: "image/jpeg",
            });
            uploadImageToServer(imageFile);

            // Stop camera stream
            if (cameraStream) {
              cameraStream.getTracks().forEach((track) => track.stop());
              setCameraStream(null);
            }
            setIsCameraActive(false);
          },
          "image/jpeg",
          0.9
        ); // Slightly reduce quality for better compatibility
      }
    }
    // Handle file upload
    else if (profileImageList[0]?.originFileObj) {
      uploadImageToServer(profileImageList[0].originFileObj);
    }
  };

  const uploadImageToServer = (fileBlob) => {
    if (!BOM.HasPermission("CREATE_CLIENTIMAGE")) {
      message.error("Insufficient privileges to upload profile image");
      setIsLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", fileBlob);

    // Additional debug for file size

    // Create custom fetch request for image upload with better error handling
    fetch(`${apiConfig.Clients}/${customerDetails.id}/images`, {
      method: "POST",
      headers: {
        Authorization: session,
        "Finsys-Platform-Tenantid": "default",
        // Don't set Content-Type here, let the browser set it with the boundary for multipart/form-data
      },
      body: formData,
    })
      .then(async (response) => {
        if (!response.ok) {
          // Try to get more detailed error message from response
          const errorText = await response.text().catch(() => "Unknown error");
          throw new Error(`Profile image upload failed (${response.status}): ${errorText}`);
        }
        return response.text(); // Use text() instead of json() for base64 response
      })
      .then((data) => {
        message.success("Profile image uploaded successfully");
        // Reload the full image to ensure we have the ID for deletion
        getProfileImage();
        setIsProfileModalVisible(false);
      })
      .catch((error) => {
        message.error(`Error uploading profile image: ${error.message}`);
      })
      .finally(() => {
        setIsLoading(false);
        setProfileImageList([]);

        // Ensure camera is fully stopped if active
        if (isCameraActive && cameraStream) {
          cameraStream.getTracks().forEach((track) => track.stop());
          setCameraStream(null);
          setIsCameraActive(false);
        }
      });
  };

  const handleDeleteProfileImage = () => {
    if (!BOM.HasPermission("DELETE_CLIENTIMAGE")) {
      message.error("Insufficient privileges to delete profile image");
      return;
    }

    Modal.confirm({
      title: "Are you sure you want to delete this profile image?",
      icon: <DeleteOutlined />,
      content: "This action cannot be undone.",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        setIsLoading(true);

        // If profileImageData has an ID, use it to delete the specific image
        const imageId = profileImageData?.id;
        const url = imageId
          ? `${apiConfig.Clients}/${customerDetails.id}/images/${imageId}`
          : `${apiConfig.Clients}/${customerDetails.id}/images`;

        fetch(url, {
          method: "DELETE",
          headers: {
            Authorization: session,
            "Finsys-Platform-Tenantid": "default",
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to delete profile image");
            }
            message.success("Profile image deleted successfully");
            setProfileImageData(null);
          })
          .catch((error) => {
            message.error("Error deleting profile image: " + error.message);
          })
          .finally(() => {
            setIsLoading(false);
          });
      },
    });
  };

  const startCamera = () => {
    if (!BOM.HasPermission("CREATE_CLIENTIMAGE")) {
      message.error("Insufficient privileges to capture profile image");
      return;
    }

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      message.error("Your browser doesn't support camera access");
      return;
    }

    setIsCameraActive(true);
    setProfileImageList([]);

    // Access the device camera with constraints for better quality
    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: "user", // Prefer front camera
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      })
      .then((stream) => {
        setCameraStream(stream);

        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play().catch((playError) => {
            message.error("Could not start video preview");
          });
        }
      })
      .catch((err) => {
        // Provide more user-friendly error messages
        if (err.name === "NotAllowedError") {
          message.error(
            "Camera access denied. Please allow camera access in your browser settings."
          );
        } else if (err.name === "NotFoundError") {
          message.error("No camera found on your device");
        } else {
          message.error(`Error accessing camera: ${err.message}`);
        }

        setIsCameraActive(false);
      });
  };

  const uploadProps = {
    listType: "picture-card",
    headers: {
      Authorization: session,
      "Finsys-Platform-Tenantid": "default",
    },
    accept: "image/*",
    onSuccess(ret) {
      getSignature();
    },
    onRemove(file) {
      if (!BOM.HasPermission("DELETE_DOCUMENT")) {
        BOM.AlertMsg(cnt.WARNING, "Insufficient privileges to delete Signature");

        return false;
      }
      if (!BOM.HasPermission("CREATE_DOCUMENT")) {
        setIsUploadDisabled(true);
      }
      return true;
    },
  };

  const profileUploadProps = {
    listType: "picture-card",
    fileList: profileImageList,
    onChange: onProfileImageChange,
    onPreview: handlePreview,
    beforeUpload: (file) => {
      // Check file type
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("You can only upload image files!");
        return false;
      }

      // Check file size (2MB limit)
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image must be smaller than 2MB!");
        return false;
      }

      // Return false to prevent auto upload
      return false;
    },
    maxCount: 1,
  };

  const getSignatureImage = async (signature) => {
    try {
      const url = `${apiConfig.Clients}/${customerDetails.id}/documents/${signature.id}/attachment?tenantIdentifier=default`;

      const { headers } = appConfig.apiSettings;
      headers.Authorization = session;

      const tfaToken = localStorage.getItem("tfaToken");
      if (tfaToken && tfaToken !== "null" && tfaToken !== "undefined") {
        headers["Fineract-Platform-TFA-Token"] = tfaToken;
      } else {
        delete headers["Fineract-Platform-TFA-Token"];
      }

      const response = await axios({
        method: "GET",
        url: url,
        headers: headers,
        responseType: "blob",
      });

      // Create object URL from blob response
      const blob = new Blob([response.data]);
      const imageUrl = URL.createObjectURL(blob);

      setIsLoading(false);

      // Return the image URL (async function automatically returns a Promise)
      return imageUrl;
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };
  const renderUploadFram = (params) => {
    // let dataParam = null;
    let endPoint = "documents";

    switch (params.key.toLowerCase()) {
      case "signature":
        // dataParam = {
        //   name: params.name,
        //   description: params.description,
        // };
        break;
      case "profile":
        endPoint = "images";
        break;
      default:
        break;
    }

    const dataParam = {
      name: params.name,
      description: params.description,
    };

    return (
      <div
        style={{
          width: 100,
          marginRight: "auto",
          display: isShowSignature ? "" : "none",
        }}
      >
        <ImgCrop rotationSlider>
          <Upload
            {...uploadProps}
            action={`${apiConfig.Clients}/${customerDetails.id}/${endPoint}`}
            fileList={fileList}
            onChange={onChange}
            onPreview={handlePreview}
            data={dataParam}
            disabled={isUploadDisabled} // Disable the upload component
          >
            {!isUploadDisabled && (fileList.length === 0 || onEditShow) && "+ Upload"}
          </Upload>
        </ImgCrop>

        {previewImage && (
          <Image
            wrapperStyle={{
              display: "none",
            }}
            preview={{
              visible: previewOpen,
              onVisibleChange: (visible) => setPreviewOpen(visible),
              afterOpenChange: (visible) => !visible && setPreviewImage(""),
            }}
            src={previewImage}
          />
        )}
      </div>
    );
  };

  // Handle image error gracefully
  const handleImageError = () => {
    // If the image fails to load, we silently let the default avatar handle it
    setProfileImageData(null);
  };

  return (
    <Form layout="vertical" autoComplete="off">
      <Spin
        spinning={props.spinning || isLoading}
        style={{
          width: "32%",
        }}
      >
        <Card
          title={
            <>
              <Tooltip title={customerDetails.displayName}>
                {BOM.SubstringFormat(customerDetails.displayName?.toUpperCase(), 25)}
              </Tooltip>{" "}
              &nbsp;| {displayStatus}
            </>
          }
          hoverable
          bordered
        >
          <Row>
            <Col span={12}>
              <div style={{ width: 130, position: "relative" }}>
                <Space direction="vertical" size={16}>
                  <Space wrap size={16}>
                    {profileImageData ? (
                      <div style={{ position: "relative" }}>
                        <Avatar
                          size={64}
                          src={
                            typeof profileImageData === "object"
                              ? profileImageData.url
                              : profileImageData
                          }
                          onError={handleImageError}
                        />
                        {BOM.HasPermission("DELETE_CLIENTIMAGE") && (
                          <Button
                            type="default"
                            shape="circle"
                            icon={<DeleteOutlined />}
                            size="small"
                            style={{ position: "absolute", top: -8, right: -8 }}
                            onClick={handleDeleteProfileImage}
                          />
                        )}
                      </div>
                    ) : (
                      <Avatar size={64} icon={<UserOutlined />} />
                    )}
                    {BOM.HasPermission("CREATE_CLIENTIMAGE") && (
                      <Button
                        type="default"
                        shape="circle"
                        icon={<CameraOutlined />}
                        size="small"
                        style={{ position: "absolute", bottom: 0, right: 40 }}
                        onClick={showProfileModal}
                      />
                    )}
                  </Space>
                </Space>
              </div>
              <Divider orientation="left" orientationMargin="0">
                Signature Info{" "}
                {isShowSignature && (
                  <Tooltip title="Signature Setup">
                    <Button
                      type="primarys"
                      shape="circle"
                      icon={<EditOutlined />}
                      onClick={() => setOnEditShow(!onEditShow)}
                      disabled={!BOM.HasPermission("CREATE_DOCUMENT")}
                    />
                  </Tooltip>
                )}
                <Tooltip title={`${isShowSignature ? "Hide" : "Show"} Signature`}>
                  <Button
                    type="primarys"
                    shape="circle"
                    icon={isShowSignature ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                    disabled={!BOM.HasPermission("READ_DOCUMENT")}
                    onClick={() => setIsShowSignature(!isShowSignature)}
                  />
                </Tooltip>
              </Divider>
              {BOM.HasPermission("READ_DOCUMENT") &&
                renderUploadFram({
                  key: "signature",
                  name: "clientSignature",
                  description: "client signature",
                })}
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label="Customer ID">
                <Input
                  value={customerDetails?.accountNo}
                  disabled
                  className="of-bold-disable-input"
                />
              </Form.Item>

              <Form.Item label="Branch Name">
                <Input
                  value={customerDetails?.officeName}
                  disabled
                  className="of-bold-disable-input"
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Spin>

      {/* Profile Image Upload Modal */}
      <Modal
        title="Update Profile Image"
        open={isProfileModalVisible}
        onCancel={handleProfileModalCancel}
        footer={[
          <Button key="back" onClick={handleProfileModalCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoading}
            onClick={handleProfileUpload}
            disabled={!isCameraActive && profileImageList.length === 0}
            style={{
              ...styles.ofPrimaryBtnColor,
            }}
          >
            {isCameraActive ? "Capture & Upload" : "Upload"}
          </Button>,
        ]}
      >
        {isCameraActive ? (
          <div style={{ textAlign: "center", margin: "20px 0" }}>
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "400px",
                margin: "0 auto",
              }}
            >
              <video ref={videoRef} style={{ width: "100%", borderRadius: "8px" }} />
              <canvas ref={canvasRef} style={{ display: "none" }} />
            </div>
          </div>
        ) : (
          <div
            style={{
              textAlign: "center",
              margin: "20px 0",
              border: "1px dashed #d9d9d9",
              padding: "20px",
            }}
          >
            <ImgCrop rotationSlider>
              <Upload {...profileUploadProps}>
                {profileImageList.length < 1 && "+ Upload Profile Image"}
              </Upload>
            </ImgCrop>

            <Divider>Or</Divider>

            <Button
              type="primary"
              icon={<CameraOutlined />}
              onClick={startCamera}
              style={{
                ...styles.ofPrimaryBtnColor,
              }}
            >
              Use Camera
            </Button>
          </div>
        )}
        <Text type="secondary" style={{ display: "block", marginTop: "20px" }}>
          {isCameraActive
            ? "Click 'Capture & Upload' to take a photo"
            : "Select a file or use your device camera to update the profile picture"}
        </Text>
      </Modal>
    </Form>
  );
}

function renderStatistic(containerWidth, text) {
  const textStyleStr = `width:${containerWidth}px;font-size:15px;font-weight:400;line-height:2;`;
  return `<div style="${textStyleStr}">${text}</div>`;
}

const AssetPositionCard = () => {
  useEffect(() => {
    const data = [
      { type: "Investment", value: 27 },
      { type: "Fixed Asset", value: 25 },
      { type: "Current Assets", value: 18 },
      { type: "Cash", value: 15 },
      { type: "Inventory", value: 10 },
      { type: "Accounts Receivable", value: 5 },
    ];

    const containerWidth = "100%"; // Specify the desired width for the pie chart
    const containerHeight = 200; // Specify the desired height for the pie chart

    const piePlot = new Pie("assetContainer", {
      appendPadding: 0,
      data,
      angleField: "value",
      colorField: "type",
      radius: 1,
      innerRadius: 0.64,
      width: containerWidth, // Set the width of the chart
      height: containerHeight, // Set the height of the chart
      meta: {
        value: {
          formatter: (v) => `${v} NGN`,
        },
      },
      label: {
        type: "inner",
        offset: "-50%",
        style: {
          textAlign: "center",
        },
        autoRotate: false,
        content: "{value}",
      },
      statistic: {
        title: {
          offsetY: -4,
          customHtml: (container, view, datum) => {
            const d = Math.sqrt(Math.pow(containerWidth / 2, 2) + Math.pow(containerHeight / 2, 2));
            const text = datum ? datum.type : "Total Assets";
            return renderStatistic(d, text);
          },
        },
        content: {
          offsetY: 4,
          style: {
            fontSize: "32px",
          },
          customHtml: (container, view, datum, data) => {
            const text = datum
              ? `NGN ${datum.value}`
              : `NGN ${data.reduce((r, d) => r + d.value, 0)}`;
            return renderStatistic(containerWidth, text);
          },
        },
      },
      interactions: [
        { type: "element-selected" },
        { type: "element-active" },
        { type: "pie-statistic-active" },
      ],
    });

    piePlot.render();

    // Cleanup function to destroy the chart when the component unmounts
    return () => {
      piePlot.destroy();
    };
  }, []); // Empty dependency array ensures this effect runs once after the initial render

  return (
    <Card title={"Asset Position"} hoverable bordered>
      <div id="assetContainer" />
    </Card>
  );
};

const LiabilityPositionCard = () => {
  useEffect(() => {
    const data = [
      { type: "Investment", value: 27 },
      { type: "Fixed Asset", value: 25 },
      { type: "Current Assets", value: 18 },
      { type: "Cash", value: 15 },
      { type: "Inventory", value: 10 },
      { type: "Accounts Receivable", value: 5 },
    ];

    const containerWidth = "100%"; // Specify the desired width for the pie chart
    const containerHeight = 200; // Specify the desired height for the pie chart

    const piePlot = new Pie("liabilityContainer", {
      appendPadding: 0,
      data,
      angleField: "value",
      colorField: "type",
      radius: 1,
      innerRadius: 0.64,
      width: containerWidth, // Set the width of the chart
      height: containerHeight, // Set the height of the chart
      meta: {
        value: {
          formatter: (v) => `${v} NGN`,
        },
      },
      label: {
        type: "inner",
        offset: "-50%",
        style: {
          textAlign: "center",
        },
        autoRotate: false,
        content: "{value}",
      },
      statistic: {
        title: {
          offsetY: -4,
          customHtml: (container, view, datum) => {
            const d = Math.sqrt(Math.pow(containerWidth / 2, 2) + Math.pow(containerHeight / 2, 2));
            const text = datum ? datum.type : "Total Liabilities";
            return renderStatistic(d, text);
          },
        },
        content: {
          offsetY: 4,
          style: {
            fontSize: "32px",
          },
          customHtml: (container, view, datum, data) => {
            const text = datum
              ? `NGN ${datum.value}`
              : `NGN ${data.reduce((r, d) => r + d.value, 0)}`;
            return renderStatistic(containerWidth, text);
          },
        },
      },
      interactions: [
        { type: "element-selected" },
        { type: "element-active" },
        { type: "pie-statistic-active" },
      ],
    });

    piePlot.render();

    // Cleanup function to destroy the chart when the component unmounts
    return () => {
      piePlot.destroy();
    };
  }, []); // Empty dependency array ensures this effect runs once after the initial render

  return (
    <Card title={"Liability Position"} hoverable bordered>
      <div id="liabilityContainer" />
    </Card>
  );
};
